export const API = {
  COMPANY_DETAIL: `company/v1/public/detail/${process.env.VUE_APP_ACCESS_KEY}`,
};

export default { API };
